/**
 * 服务端统一挂载前缀（与后端 env.SERVER_PATH 保持一致）
 *
 * 设置后所有服务端分区收口到该前缀下：
 *   /api/* → {SERVER_PATH}/api/*
 *   /file/* → {SERVER_PATH}/file/*
 *   /pub/random → {SERVER_PATH}/pub/random
 *   /dav/* → {SERVER_PATH}/dav/*
 *
 * 构建时通过 VUE_APP_SERVER_PATH 注入（.env.production 或部署环境变量），
 * 默认空字符串 = 行为与原先完全一致（根路径部署）。
 */
const normalized = (process.env.VUE_APP_SERVER_PATH || 'imghub').trim().replace(/^\/+|\/+$/g, '');
export const SERVER_PATH = normalized ? '/' + normalized : '';

/**
 * 拼接服务端绝对路径（如 '/file/xxx'、'/api/xxx'）
 */
export function serverPath(path) {
    return SERVER_PATH + path;
}
